import React, { FormEvent } from 'react';
import { Button, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { SpecialtyQueryParams } from './hooks/useFetchSpecialties';
import FilterBox from 'components/filter-box/FilterBox';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type SpecialtyFilterBoxProps = {
  filter: SpecialtyQueryParams;
  handleChange<K extends keyof SpecialtyQueryParams>(index: K, value: SpecialtyQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const SpecialtyFilterBox: React.FC<SpecialtyFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome"
          placeholder="Digite o nome da especialidade"
          value={filter.name}
          autoFocus
          onChange={e => handleChange('name', e.target.value)}
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default SpecialtyFilterBox;
